import React 		from 'react';
import ReactDOM from 'react-dom';

import BLComponent from '../core/_BLComponent.jsx';

import {ClickShowTooltip, CustomConfirm, CustomAlert} from '../common/_Utilities.jsx';

export default class OTPRequest extends BLComponent {

	constructor(props, context) {
		super(props, context);

		this.state = {
			emailAddress: blapp.session.getMe().skEmailAddr,
			confirmationCode: '',
			errorMessage: '',
			showResend: false,
			resendCodeSuccess: false
		}
		this._redirectUrl = blapp.util.getUrlVar( "returnTo" );
	}

	componentDidMount() {
		this.sendCode(false);
	}

	render() {
		return (
			<div className="main l-margin-y--xxl main--x-thin">
				<div className="main__content">
					{this.state.errorMessage && 
						<div className="notification notification--error notification--tight l-flex l-split l-margin-bottom">
							<div className="l-flex">
								<i className="fas fa-exclamation-triangle text-color--primaryRed l-margin-right--sm l-margin-top--xxs"/>
								<p><strong>{this.state.errorMessage}</strong></p>
							</div>
							{this.state.showResend && <button className="btn btn--link text--underline text-color--black l-margin-left--sm" onClick={() => this.sendCode(true)}>Resend</button>}
						</div>
					}
					
					<h1 className="l-margin-bottom text--small-title l-block text--center text--bold">Confirmation code required</h1>
					{this.state.resendCodeSuccess && 
						<div className="notification notification--success notification--tight l-flex l-center l-margin-bottom--l l-margin-top--l">
							<i className="fas fa-check text-color--primaryGreen l-margin-right--sm"/>
							<p><strong>A new code as been sent to your email</strong></p>
						</div>
					}
					<p className="text--center l-margin-bottom">To access your seller features, you’ll need to enter the confirmation code we’ve sent to the following email address: <strong>{this.state.emailAddress}</strong>. <a className="btn btn--link" href={blapp.url2.getClassicHelpCenterUrl(2615)} target="_blank" rel="noreferrer noopener">Learn more</a></p>
					<p className="l-margin-bottom--l text--center">This code will expire in 10 minutes.</p>
					<label className="text--bold l-block l-margin-bottom--sm" htmlFor="confirmation-code">Confirmation code</label>
					<input type="text" className="text-input text-input--med l-full-width" id="confirmation-code" placeholder="Confirmation code" value={this.state.confirmationCode} onChange={(e) => this.setState({confirmationCode: e.target.value})}/>
					<button className="btn btn--cta text--bold l-margin-top l-margin-bottom l-block l-full-width" disabled={!this.state.confirmationCode} onClick={() => this.triggerSubmit()}>Submit</button>
					<div className="text--center text--small">
						<p>Haven't received an email?</p>
						<p><button className="btn btn--link" onClick={() => this.sendCode(true)}>Resend code</button> or get <a className="btn btn--link" href={blapp.url2.getClassicHelpCenterUrl(2615)} target="_blank" rel="noreferrer noopener">additional support</a></p> 
					</div>
				</div>
			</div>
		);
	}

	triggerSubmit() {
		this.setState({noAccount: false, emailError: false});
		blapp.models.fetch(
			"_rverifyOTPCode"
		,	{
				controller:	"store.BLCStoreOTP"
			,	method:		"verifyOTPCode"
			,	params:		[this.state.confirmationCode, false]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				if (data == "EC_OK") {
					window.location.href = this._redirectUrl;
				} else if (data == "EC_MFA_CODE_MISMATCH") {
					this.setState({resendCodeSuccess: false, errorMessage: "Confirmation code didn't match.", showResend: false});
				} else if (data == "EC_MFA_CODE_EXPIRED") {
					this.setState({resendCodeSuccess: false, errorMessage: "Confirmation code expired.", showResend: true});
				} else {
					this.setState({resendCodeSuccess: false, errorMessage: "There was an error submitting the confirmation code. Please try again.", showResend: false});
				}
			}
		).catch ( 
			( error ) =>
			{
				this.setState({resendCodeSuccess: false, errorMessage: "There was an error submitting the confirmation code. Please try again.", showResend: false});
			}
		);
		
	}

	sendCode( bResend ) {
		blapp.models.fetch(
			"_requestOTPCode"
		,	{
				controller:	"store.BLCStoreOTP"
			,	method:		"requestOTPCode"
			,	params:		[bResend]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				if (data.errorCode == "EC_OK") {
					if (bResend) {
						this.setState({emailAddress: data.data, resendCodeSuccess: true, errorMessage: '', showResend: false})
					}
				} else {
					this.setState({resendCodeSuccess: false, errorMessage: 'There was an error sending the email. Please try again later.', showResend: false});
				}
			}
		).catch ( 
			( error ) =>
			{
				this.triggerAlert('There was an error sending the email. Please try again later.');
			}
		);
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}


};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<OTPRequest blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);